export default {
    name: 'Display',
    dimensions: { width: 40, height: 40 },
    content: `
    <g fill="currentColor" stroke="none">
    <path d="M38 40H2C0.9 40 0 39.1 0 38V2C0 0.9 0.9 0 2 0H38C39.1 0 40 0.9 40 2V38C40 39.1 39.1 40 38 40ZM2 2V37C2 37.55 2.45 38 3 38H38V3C38 2.45 37.55 2 37 2H2Z" />
    <path d="M11 35H7C5.9 35 5 34.1 5 33V29C5 28.45 5.45 28 6 28C6.55 28 7 28.45 7 29V32C7 32.55 7.45 33 8 33H11C11.55 33 12 33.45 12 34C12 34.55 11.55 35 11 35Z" />
    <path d="M34 12C33.45 12 33 11.55 33 11V8C33 7.45 32.55 7 32 7H29C28.45 7 28 6.55 28 6C28 5.45 28.45 5 29 5H33C34.1 5 35 5.9 35 7V11C35 11.55 34.55 12 34 12Z" />
    <path d="M6 12C5.45 12 5 11.55 5 11V7C5 5.9 5.9 5 7 5H11C11.55 5 12 5.45 12 6C12 6.55 11.55 7 11 7H7V11C7 11.55 6.55 12 6 12Z" />
    <path d="M33 35H29C28.45 35 28 34.55 28 34C28 33.45 28.45 33 29 33H33V29C33 28.45 33.45 28 34 28C34.55 28 35 28.45 35 29V33C35 34.1 34.1 35 33 35Z" />
    </g>
  `
};
